var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndiaIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H23V5.66667H0V0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.66675H23V11.3334H0V5.66675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3333H23V16.9999H0V11.3333Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5002 10.7667C12.7705 10.7667 13.8002 9.75191 13.8002 8.50007C13.8002 7.24822 12.7705 6.2334 11.5002 6.2334C10.2299 6.2334 9.2002 7.24822 9.2002 8.50007C9.2002 9.75191 10.2299 10.7667 11.5002 10.7667Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4998 10.4833C12.6113 10.4833 13.5123 9.5953 13.5123 8.49993C13.5123 7.40457 12.6113 6.5166 11.4998 6.5166C10.3883 6.5166 9.4873 7.40457 9.4873 8.49993C9.4873 9.5953 10.3883 10.4833 11.4998 10.4833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5002 8.8966C11.7225 8.8966 11.9027 8.71901 11.9027 8.49994C11.9027 8.28087 11.7225 8.10327 11.5002 8.10327C11.2779 8.10327 11.0977 8.28087 11.0977 8.49994C11.0977 8.71901 11.2779 8.8966 11.5002 8.8966Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4818 8.86059C13.5385 8.86794 13.5905 8.82863 13.598 8.77277C13.6054 8.71692 13.5655 8.66569 13.5089 8.65833C13.4522 8.65098 13.4002 8.6903 13.3927 8.74615C13.3853 8.802 13.4252 8.85323 13.4818 8.86059Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5002 10.4832L11.5692 9.29323L11.5002 8.72656L11.4312 9.29323L11.5002 10.4832Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3194 9.35422C13.372 9.37564 13.4326 9.3507 13.4546 9.29852C13.4766 9.24634 13.4518 9.18667 13.3991 9.16525C13.3464 9.14383 13.2859 9.16877 13.2639 9.22095C13.2418 9.27313 13.2667 9.33279 13.3194 9.35422Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9788 10.4158L11.3582 9.28344L11.4415 8.71855L11.2262 9.24867L10.9788 10.4158Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0329 9.78963C13.0781 9.82378 13.1431 9.81511 13.1781 9.77028C13.213 9.72544 13.2047 9.66141 13.1595 9.62726C13.1143 9.59311 13.0493 9.60178 13.0144 9.64661C12.9794 9.69145 12.9877 9.75548 13.0329 9.78963Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4934 10.2184L11.157 9.22123L11.3855 8.69657L11.0384 9.15376L10.4934 10.2184Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6422 10.1365C12.6769 10.1811 12.7419 10.1893 12.7873 10.1549C12.8328 10.1204 12.8416 10.0564 12.8069 10.0118C12.7722 9.96728 12.7073 9.95906 12.6618 9.99348C12.6163 10.0279 12.6076 10.0919 12.6422 10.1365Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0766 9.90282L10.9793 9.10878L11.3376 8.66011L10.8823 9.01318L10.0766 9.90282Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1744 10.3715C12.1965 10.4237 12.257 10.4487 12.3097 10.4273C12.3623 10.4059 12.3871 10.3462 12.3651 10.294C12.3431 10.2418 12.2825 10.2168 12.2299 10.2382C12.1772 10.2596 12.1524 10.3193 12.1744 10.3715Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75776 9.49098L10.8379 8.9559L11.3009 8.61353L10.7683 8.83725L9.75776 9.49098Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6597 10.4793C11.6674 10.5353 11.7193 10.5749 11.7759 10.5677C11.8324 10.5605 11.872 10.5092 11.8644 10.4532C11.8568 10.3972 11.8048 10.3576 11.7483 10.3648C11.6917 10.372 11.6521 10.4233 11.6597 10.4793Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55652 9.01237L10.7407 8.77158L11.2778 8.55901L10.7045 8.63892L9.55652 9.01237Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.134 10.453C11.1267 10.5087 11.1669 10.56 11.2237 10.5675C11.2805 10.575 11.3325 10.5359 11.3398 10.4802C11.3471 10.4245 11.307 10.3733 11.2501 10.3658C11.1933 10.3583 11.1413 10.3973 11.134 10.453Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48818 8.49755L10.6956 8.56649L11.2702 8.50285L10.6952 8.43579L9.48818 8.49755Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6338 10.2934C10.612 10.3454 10.6372 10.405 10.69 10.4267C10.7429 10.4483 10.8035 10.4237 10.8253 10.3717C10.8471 10.3197 10.8219 10.2601 10.769 10.2384C10.7161 10.2168 10.6556 10.2414 10.6338 10.2934Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55617 7.9863L10.7049 8.36009L11.2782 8.44159L10.7404 8.22935L9.55617 7.9863Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1925 10.0115C10.1575 10.0563 10.1658 10.1204 10.211 10.1545C10.2562 10.1886 10.3212 10.18 10.3562 10.1351C10.3911 10.0903 10.3828 10.0263 10.3376 9.99213C10.2924 9.95798 10.2274 9.96665 10.1925 10.0115Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75754 7.50878L10.7681 8.16251L11.3007 8.38623L10.8377 8.04385L9.75754 7.50878Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84048 9.62638C9.79499 9.66082 9.78619 9.72485 9.82084 9.7694C9.85549 9.81395 9.92046 9.82214 9.96596 9.7877C10.0115 9.75326 10.0203 9.68923 9.9856 9.64468C9.95095 9.60014 9.88598 9.59194 9.84048 9.62638Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0774 7.09817L10.8816 7.98759L11.3371 8.33967L10.9799 7.89078L10.0774 7.09817Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60076 9.16464C9.54784 9.18631 9.52257 9.24597 9.54434 9.29791C9.5661 9.34984 9.62664 9.37438 9.67956 9.35271C9.73249 9.33104 9.75775 9.27138 9.73599 9.21944C9.71423 9.16751 9.65368 9.14297 9.60076 9.16464Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4941 6.78279L11.0374 7.84729L11.3848 8.30372L11.1575 7.77891L10.4941 6.78279Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49167 8.65712C9.43488 8.66458 9.3948 8.71581 9.40215 8.77156C9.4095 8.8273 9.46149 8.86643 9.51827 8.85897C9.57506 8.85151 9.61514 8.80027 9.60779 8.74453C9.60044 8.68879 9.54845 8.64965 9.49167 8.65712Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9798 6.58443L11.2246 7.75143L11.4402 8.28093L11.3588 7.71592L10.9798 6.58443Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51806 8.13913C9.46155 8.13193 9.40956 8.1715 9.40194 8.22751C9.39432 8.28352 9.43394 8.33475 9.49045 8.34195C9.54696 8.34915 9.59895 8.30958 9.60658 8.25357C9.6142 8.19756 9.57457 8.14632 9.51806 8.13913Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5027 6.51692L11.4327 7.70684L11.4972 8.27316L11.5652 7.70642L11.5027 6.51692Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68064 7.64579C9.62797 7.62436 9.56742 7.6493 9.54541 7.70148C9.5234 7.75366 9.54825 7.81332 9.60092 7.83475C9.65359 7.85617 9.71414 7.83124 9.73615 7.77906C9.75816 7.72688 9.73331 7.66721 9.68064 7.64579Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0212 6.58396L11.6418 7.71632L11.5585 8.2812L11.7738 7.75109L12.0212 6.58396Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96707 7.21061C9.92187 7.17647 9.8569 7.18513 9.82196 7.22997C9.78701 7.27481 9.79532 7.33884 9.84052 7.37298C9.88572 7.40713 9.95069 7.39847 9.98564 7.35363C10.0206 7.30879 10.0123 7.24476 9.96707 7.21061Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5067 6.78206L11.843 7.77927L11.6145 8.30392L11.9616 7.84672L12.5067 6.78206Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3579 6.86372C10.3232 6.81917 10.2583 6.81098 10.2128 6.84541C10.1673 6.87985 10.1585 6.94388 10.1931 6.98843C10.2278 7.03298 10.2927 7.04118 10.3382 7.00674C10.3837 6.9723 10.3925 6.90827 10.3579 6.86372Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9235 7.09739L12.0208 7.89151L11.6625 8.34017L12.1177 7.98704L12.9235 7.09739Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8256 6.62852C10.8035 6.57632 10.743 6.55135 10.6903 6.57275C10.6377 6.59415 10.6129 6.65381 10.6349 6.70602C10.6569 6.75822 10.7175 6.78319 10.7701 6.76179C10.8228 6.74039 10.8476 6.68072 10.8256 6.62852Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 7.50877L12.1621 8.04385L11.6991 8.38623L12.2317 8.16251L13.2422 7.50877Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3403 6.52048C11.3326 6.46447 11.2807 6.4249 11.2241 6.43209C11.1676 6.43929 11.128 6.49052 11.1356 6.54653C11.1432 6.60254 11.1952 6.64212 11.2517 6.63492C11.3083 6.62773 11.3479 6.57649 11.3403 6.52048Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4435 7.98739L12.2593 8.22817L11.7222 8.44075L12.2955 8.36083L13.4435 7.98739Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8665 6.54756C11.8738 6.49189 11.8336 6.44065 11.7768 6.43312C11.7199 6.42559 11.6679 6.46462 11.6606 6.52029C11.6534 6.57596 11.6936 6.6272 11.7504 6.63473C11.8073 6.64226 11.8593 6.60324 11.8665 6.54756Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5122 8.50324L12.3048 8.43418L11.7302 8.49725L12.3053 8.56419L13.5122 8.50324Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3663 6.70749C12.3881 6.65554 12.3628 6.59587 12.3099 6.57422C12.257 6.55257 12.1965 6.57713 12.1747 6.62908C12.1529 6.68103 12.1781 6.7407 12.2311 6.76235C12.284 6.784 12.3445 6.75944 12.3663 6.70749Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4439 9.01408L12.295 8.64025L11.7218 8.55854L12.2596 8.77073L13.4439 9.01408Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8079 6.98946C12.8427 6.94484 12.834 6.88081 12.7886 6.84645C12.7431 6.81208 12.6782 6.82039 12.6434 6.86501C12.6087 6.90963 12.6174 6.97366 12.6628 7.00803C12.7082 7.04239 12.7732 7.03408 12.8079 6.98946Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2429 9.49197L12.2313 8.838L11.6989 8.6132L12.1626 8.95535L13.2429 9.49197Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1599 7.37432C13.2052 7.3401 13.2136 7.27607 13.1788 7.23131C13.1439 7.18654 13.0789 7.17799 13.0336 7.21221C12.9884 7.24643 12.9799 7.31046 13.0148 7.35523C13.0497 7.39999 13.1146 7.40854 13.1599 7.37432Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9231 9.90281L12.1177 9.01321L11.6624 8.66033L12.0205 9.10905L12.9231 9.90281Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3996 7.83586C13.4523 7.81437 13.4773 7.7547 13.4553 7.70259C13.4334 7.65047 13.3728 7.62564 13.3201 7.64713C13.2674 7.66862 13.2424 7.72828 13.2643 7.7804C13.2863 7.83251 13.3468 7.85734 13.3996 7.83586Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5069 10.2177L11.9624 9.15305L11.6152 8.6961L11.8433 9.22081L12.5069 10.2177Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5092 8.34338C13.5658 8.3361 13.6055 8.28486 13.598 8.22894C13.5905 8.17302 13.5385 8.13359 13.4819 8.14087C13.4253 8.14815 13.3855 8.19939 13.393 8.25531C13.4006 8.31123 13.4526 8.35066 13.5092 8.34338Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.021 10.4161L11.7744 9.24899L11.559 8.71907L11.6417 9.28399L12.021 10.4161Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaIn);
export default __webpack_public_path__ + "static/media/India (IN).09e25f20afdc49d5e278209ad78d90bb.svg";
export { ForwardRef as ReactComponent };